var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contents_container"},[_c('div',{staticClass:"consert_inner"},[(_vm.isMan)?_c('PrivacyPolicyPageForMens'):_vm._e(),(!_vm.isMan)?_c('PrivacyPolicyPageForWoMens'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }